import { createReducer, on } from '@ngrx/store';
import * as CommentActions from './comment.actions';
import { initialCommentState } from './comment.state';

export const commentReducer = createReducer(
  initialCommentState,
  on(CommentActions.resetComments, () => initialCommentState),
  on(CommentActions.clearCommentErrors, (state) => ({
    ...state,
    error: null,
    submitError: null,
  })),
  on(CommentActions.loadComments, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(CommentActions.loadCommentsSuccess, (state, { comments }) => ({
    ...state,
    comments,
    loading: false,
  })),
  on(CommentActions.loadCommentsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(CommentActions.addComment, (state) => ({
    ...state,
    submitting: true,
    submitError: null,
  })),
  on(CommentActions.addCommentSuccess, (state, { comment }) => ({
    ...state,
    comments: [comment, ...state.comments],
    submitting: false,
  })),
  on(CommentActions.addCommentFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    submitError: error,
  })),
  on(CommentActions.updateComment, (state) => ({
    ...state,
    submitting: true,
    submitError: null,
  })),
  on(CommentActions.updateCommentSuccess, (state, { comment }) => ({
    ...state,
    comments: state.comments.map((c) => (c.id === comment.id ? comment : c)),
    submitting: false,
  })),
  on(CommentActions.updateCommentFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    submitError: error,
  })),
  on(CommentActions.deleteComment, (state) => ({
    ...state,
    submitting: true, // Or a specific 'deleting' flag if preferred
    submitError: null,
  })),
  on(CommentActions.deleteCommentSuccess, (state, { commentId }) => ({
    ...state,
    comments: state.comments.filter((comment) => comment.id !== commentId),
    submitting: false, // Or a specific 'deleting' flag
  })),
  on(CommentActions.deleteCommentFailure, (state, { error }) => ({
    ...state,
    submitting: false, // Or a specific 'deleting' flag
    submitError: error,
  }))
);
